import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DialogClick, DialogType, IDialogPayload, IDialogState } from 'src/types/Dialog';

const initialState: IDialogState = {
  text: '',
  open: false,
  okText: '',
  cancelText: '',
  dlgClick: undefined,
  type: DialogType.None,
  title: ''
};

export const dialog = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    closeDlg: state => {
      state.open = false;
    },
    openDlg: (state, action: PayloadAction<IDialogPayload>) => {
      state.open = true;
      state.text = action.payload.text;
      state.okText = action.payload.okText;
      state.cancelText = action.payload.cancelText;
      state.title = action.payload.title;
    },
    clearDlgState: state => {
      state.open = false;
      state.text = '';
      state.okText = '';
      state.cancelText = '';
      state.type = DialogType.None;
      state.title = '';
    },
    onDlgOkClick: state => {
      state.open = false;
      state.dlgClick = DialogClick.Ok;
    },
    onDlgCancelClick: state => {
      state.open = false;
      state.dlgClick = DialogClick.Cancel;
    },
    setDataDlg: state => {
      state.type = DialogType.Data;
    },
    clearDlgType: state => {
      state.type = DialogType.None;
    }
  }
});

export const { closeDlg, openDlg, clearDlgState, onDlgOkClick, onDlgCancelClick, setDataDlg, clearDlgType } =
  dialog.actions;
